import { NgModule } from '@angular/core';

import { DxPopupModule } from 'devextreme-angular';

import { SharedModule } from 'src/app/shared.module';
import { DevPopupComponent } from './dev-popup.component';

@NgModule({
  imports: [SharedModule, DxPopupModule],
  declarations: [DevPopupComponent],
  exports: [DevPopupComponent],
})
export class DevPopUpModule {}
